import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { MarkdownContent } from '../components/MarkdownContent';
import { StepNavigation } from '../components/StepNavigation';
import { getStepByPath, steps } from '../config/steps';
import { useMarkdown } from '../hooks/useMarkdown';
import { usePlatform } from '../hooks/usePlatform';

export const StepPage: React.FC = () => {
  const { stepId } = useParams<{ stepId: string }>();
  const currentPath = `/${stepId}`;
  const currentStep = getStepByPath(currentPath);
  const { platform } = usePlatform();

  // Get the appropriate content file based on platform
  const contentFile = currentStep
    ? platform === 'ios'
      ? currentStep.contentFileiOS
      : currentStep.contentFileAndroid
    : '';

  const { content, loading, error } = useMarkdown(contentFile);

  // Redirect to first step if step not found
  if (!currentStep) {
    return <Navigate to='/obezbedi' replace />;
  }

  return (
    <div className='content-wrapper'>
      {/* Step header */}
      <div className='step-header'>
        <div className='step-meta'>
          <div className='flex-1'></div>
          <span>Korak {steps.findIndex(s => s.id === currentStep.id) + 1}</span>
          <span>od</span>
          <span>{steps.length}</span>
          <div className='flex-1'></div>
        </div>
        <h1 className='step-title'>{currentStep.title}</h1>
        <p className='step-description'>{currentStep.description}</p>
      </div>

      {/* Content */}
      <div className='card card-padding'>
        <MarkdownContent content={content} loading={loading} error={error} />

        <StepNavigation currentStep={currentStep} />
      </div>
    </div>
  );
};
